import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { Production } from '@/models/production';

const baseUrl = urlBuilder('medatec', 'keycards/info');

export const productionApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['PRODUCTIONS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getProductions: builder.query<Production[], void>({
                query: () => baseUrl,
                transformResponse: (response: { cardTypes: Production[] }) => {
                    return response.cardTypes;
                },
                providesTags: ['PRODUCTIONS'],
            }),
        }),
    });

export const { useGetProductionsQuery } = productionApi;
